import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Phone, Target, Award, Users, TrendingUp } from 'lucide-react';
import './SobreNosotros.css';

const SobreNosotros = () => {
  const navigate = useNavigate();
  const whatsappNumber = '5493413047536';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=¡Hola!%20Quiero%20conocer%20más%20sobre%20Meyle`;

  const representaciones = [
    {
      id: 1,
      logo: '/assets/logos/KSB-LOGO.png',
      title: 'KSB',
      description: 'Líder mundial en sistemas de bombeo y válvulas industriales. Con más de 150 años de experiencia, KSB es sinónimo de confiabilidad, innovación y rendimiento en los sectores de agua, industria, energía y construcción.',
      link: '/ksb'
    },
    {
      id: 2,
      logo: '/assets/logos/TECNAL-LOGO.png',
      title: 'TECNAL',
      description: 'Referente en equipos industriales para plantas aceiteras, bioetanol, alimentación animal, almacenamiento de granos y movimiento portuario. TECNAL combina innovación tecnológica con más de 45 años de experiencia.',
      link: '/representaciones/tecnal'
    }
  ];

  const valores = [
    {
      icon: <Award size={28} />,
      titulo: 'Calidad',
      descripcion: 'Representamos marcas líderes internacionales que garantizan productos confiables y de larga duración.'
    },
    {
      icon: <Users size={28} />,
      titulo: 'Compromiso',
      descripcion: 'Acompañamos a nuestros clientes en todas las etapas del proyecto, desde la selección hasta el servicio post-venta.'
    },
    {
      icon: <Target size={28} />,
      titulo: 'Experiencia',
      descripcion: 'Más de 30 años en el mercado argentino nos respaldan como referentes en soluciones industriales.'
    },
    {
      icon: <TrendingUp size={28} />,
      titulo: 'Innovación',
      descripcion: 'Ofrecemos tecnología de última generación que optimiza procesos y reduce costos operativos.'
    }
  ];

  return (
    <div className="sobre-nosotros-container">
      {/* Hero Section */}
      <section className="sobre-hero">
        <div className="sobre-hero-content">
          <h1 className="sobre-hero-title">Sobre Nosotros</h1>
          <p className="sobre-hero-subtitle">
            Más de 30 años conectando la industria argentina con la mejor tecnología internacional
          </p>
        </div>
      </section>

      {/* Historia */}
      <section className="sobre-historia-section">
        <div className="container">
          <h2 className="section-title">Nuestra Historia</h2>
          <div className="sobre-historia-content">
            <div className="sobre-historia-text">
              <p className="sobre-historia-paragraph">
                Desde <strong>1991</strong>, acompañamos el crecimiento de la industria en Argentina, 
                trabajando como nexo entre los fabricantes líderes y las empresas industriales de la región.
              </p>
              <p className="sobre-historia-paragraph">
                Ofrecemos equipos confiables y soporte especializado para plantas productivas de distintos sectores, 
                desde agua y saneamiento hasta agroindustria y energía.
              </p>
              <p className="sobre-historia-paragraph">
                Nuestra misión es acercar a las industrias locales la tecnología y calidad de marcas internacionales consolidadas, 
                contribuyendo a mejorar sus procesos y su eficiencia operativa.
              </p>
            </div>
            <div className="sobre-historia-image">
              <div className="sobre-historia-placeholder">
                <img 
                  src="https://customer-assets.emergentagent.com/job_c92a1987-c161-4ac3-829f-f0f2a265b7d9/artifacts/cdvavdm4_logo-meyle.jpg" 
                  alt="Meyle Logo" 
                  className="sobre-logo"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="sobre-valores-section">
        <div className="container">
          <h2 className="section-title">Nuestros Valores</h2>
          <div className="sobre-valores-grid">
            {valores.map((valor, idx) => (
              <div key={idx} className="sobre-valor-card">
                <div className="sobre-valor-icon">{valor.icon}</div>
                <h3 className="sobre-valor-titulo">{valor.titulo}</h3>
                <p className="sobre-valor-descripcion">{valor.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Representaciones */}
      <section className="sobre-representaciones-section">
        <div className="container">
          <h2 className="section-title">Nuestras Representaciones</h2>
          <div className="sobre-representaciones-grid">
            {representaciones.map((rep) => (
              <Card 
                key={rep.id} 
                className="sobre-representacion-card-new"
                onClick={() => navigate(rep.link)}
              >
                <CardContent className="sobre-card-content">
                  <div className="sobre-card-logo-container">
                    <img src={rep.logo} alt={rep.title} className="sobre-card-logo" />
                  </div>
                  <h3 className="sobre-card-title">{rep.title}</h3>
                  <p className="sobre-card-description">{rep.description}</p>
                  <span className="card-grid-arrow">→</span>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="sobre-cta-section">
        <div className="container">
          <h2 className="sobre-cta-title">Representamos tecnología que potencia la eficiencia y confiabilidad de tus procesos</h2>
          <Button 
            size="lg" 
            className="sobre-cta-button"
            onClick={() => window.open(whatsappLink, '_blank')}
          >
            <Phone className="mr-2" size={20} />
            Contactanos
          </Button>
        </div>
      </section>
    </div>
  );
};

export default SobreNosotros;
